/* eslint-disable import/prefer-default-export */
/* eslint-disable no-underscore-dangle */
/* eslint-disable global-require */

import Vue from 'vue';

import 'bootstrap';
// import BootstrapVue from 'bootstrap-vue/src/index';
import BootstrapVue from 'bootstrap-vue';

import Notifications from 'vue-notification';
import ToggleButton from 'vue-js-toggle-button';
import VueChatScroll from 'vue-chat-scroll';
import VueMatomo from 'vue-matomo';
import VuePlyr from 'vue-plyr';
import VueSweetalert2 from 'vue-sweetalert2';
import VueYoutube from 'vue-youtube';
import VueTimeago from 'vue-timeago';

import Echo from 'laravel-echo';

import './config';
import App from './App.vue';
import i18n from './lang/lang';
import router from './router';
import store from './vuex/store';
import './auth';
import './registerServiceWorker';
import './mixins/filters';

import customConverter from './toNowConverter';

// window.$ = require('jquery');

Vue.use(BootstrapVue);

Vue.use(Notifications);
Vue.use(ToggleButton);
Vue.use(VueChatScroll);
Vue.use(VuePlyr);
Vue.use(VueSweetalert2);
Vue.use(VueYoutube);

Vue.use(VueTimeago, {
  name: 'Timeago',
  locale: 'en', // default locale
  locales: {
    fr: require('date-fns/locale/fr'),
    es: require('date-fns/locale/es'),
  },
  converter: customConverter,
});

// VUE-FORM-GENERATOR
let VueFormGenerator = require('vue-form-generator');
// Fix between local and exported project
if (VueFormGenerator.default) {
  VueFormGenerator = VueFormGenerator.default;
}

const {
  fieldCheckbox,
  fieldChecklist,
  fieldInput,
  fieldLabel,
  fieldRadios,
  fieldSelect,
  fieldSubmit,
  fieldTextArea,
  fieldUpload,
  fieldCleave,
  fieldDateTimePicker,
  fieldGoogleAddress,
  fieldImage,
  fieldMasked,
  fieldNoUiSlider,
  fieldPikaday,
  fieldRangeSlider,
  fieldSelectEx,
  fieldSpectrum,
  fieldStaticMap,
  fieldSwitch,
  fieldVueMultiSelect,
} = VueFormGenerator.fieldsLoader;

Vue.use(VueFormGenerator, {
  fields: [
    // custom start
    // fieldVueCalendar,
    // fieldVueToggleButton,
    // fieldVueSliderComponent,
    // custom end
    fieldCheckbox,
    fieldChecklist,
    fieldInput,
    fieldLabel,
    fieldRadios,
    fieldSelect,
    fieldSubmit,
    fieldTextArea,
    fieldUpload,
    fieldCleave,
    fieldDateTimePicker,
    fieldGoogleAddress,
    fieldImage,
    fieldMasked,
    fieldNoUiSlider,
    fieldPikaday,
    fieldRangeSlider,
    fieldSelectEx,
    fieldSpectrum,
    fieldStaticMap,
    fieldSwitch,
    fieldVueMultiSelect,
  ],
});
// VUE-FORM-GENERATOR

// const isProd = true;

// Vue.prototype.$prerendering = (typeof window.__PRERENDER_INJECTED !== 'undefined' && window.__PRERENDER_INJECTED.IS_PRERENDERING);

// if (process.env.VUE_APP_PLATFORM === 'electron') {
//   Vue.prototype.$baseUrl = `${__static}/`;
// } else {
//   Vue.prototype.$baseUrl = process.env.BASE_URL;
// }

// console.log('BASE_URL', process.env.BASE_URL);
// console.log('baseUrl', Vue.prototype.$baseUrl);
// console.log('logo.png', `${Vue.prototype.$baseUrl}theme/img/logo.png`);

// console.log('prerendering - status', Vue.prototype.$prerendering);

// console.log('main.env', process.env);

/* matomo */
Vue.use(VueMatomo, {
  // Configure your matomo server and site
  host: 'https://matomo.mad.social',
  siteId: 1,

  // Enables automatically registering pageviews on the router
  router,

  // Enables link tracking on regular links. Note that this won't
  // work for routing links (ie. internal Vue router links)
  // Default: true
  enableLinkTracking: true,

  // Require consent before sending tracking information to matomo
  // Default: false
  requireConsent: false,

  // Whether to track the initial page view
  // Default: true
  trackInitialView: true,

  // Changes the default .js and .php endpoint's filename
  // Default: 'piwik'
  trackerFileName: 'piwik',

  // Whether or not to log debug information
  // Default: false
  debug: false,
});

// Now you can access piwik api in components through
// this.$matomo;
// or
// window._paq.push;
// or through
// window.Piwik.getTracker;
/* matomo */

let pusherConfig;

if (process.env.NODE_ENV === 'development' && !process.env.CORDOVA_PLATFORM) {
  pusherConfig = {
    broadcaster: 'pusher',
    key: 'prXug7n9DOKRIn', // laravel-websockets
    wsHost: 'socketmaster.test',
    wssPort: 6001,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
  };
} else {
  pusherConfig = {
    broadcaster: 'pusher',
    key: 'prXug7n9DOKRIn', // laravel-websockets
    wsHost: 'socket.mad.social',
    wssPort: 443,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
  };
}

// if (Vue.prototype.$prerendering === false) {
window.Pusher = require('pusher-js');

window.Echo = new Echo(pusherConfig);

window.Echo.connector.pusher.config.authEndpoint = `${Vue.prototype.$api}/broadcasting/auth`;
// }

window.Bus = new Vue();

/* Global Components */
Vue.component('VueHeadful', () => import('vue-headful'));
Vue.component('Debug', () => import('@/components/Debug.vue'));
Vue.component('Spinner', () => import('@/components/Spinner'));
Vue.component('Wrapper', () => import('@/components/layout/Wrapper.vue'));
Vue.component('TableServer', () => import('@/components/tables/TableServer.vue'));

Vue.config.productionTip = false;

export const app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  computed: {
    isAuthenticated() {
      // console.log('main.computed.isAuthenticated', this.$auth.check());
      return this.$auth.check();
    },
  },
  watch: {
    isAuthenticated() {
      // console.log('main.watch.isAuthenticated', this.$auth.token());
      window.Echo.connector.pusher.config.auth.headers.Authorization = `Bearer ${this.$auth.token()}`;
    },
  },
  mounted() {
    if (process.env.VUE_APP_PLATFORM === 'electron') {
      // Prevent blank screen in Electron builds
      this.$router.push('/');
    }
  },
  render: h => h(App),
});
